import * as Sentry from "@sentry/browser";
import {Integrations} from "@sentry/tracing";
import {getMetaContent} from "pf/helper";

Sentry.init({
    dsn: getMetaContent('sentry-dsn'),
    release: getMetaContent('sentry-release'),
    environment: getMetaContent('sentry-environment'),
    integrations: [
        new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: ["Can't find variable: _AutofillCallbackHandler", "Request failed with status code 401"]
});
